// extracted by mini-css-extract-plugin
module.exports = {"container":"container-1Pbv2","tag":"tag-1YhpU","placeholder":"placeholder-3_fwJ","placeholderContent":"placeholderContent-3bajj"};